import { FC } from 'react';
import { PageHeader } from '#dashboard/components/pageHeader.component';
import { EsimsTable } from '#esims/components/esimsTable.component';
import { useAppContext } from '#hooks';
import { CustomStatsButton } from '#esims/components/customStatsButton.component';
import { isZim } from '../../services/helpers';
import { RefreshWebsiteSalesButton } from '#esims/components/refreshWebsiteButton.component';

export const EsimsPage: FC = () => {

    const { loggedInUser } = useAppContext()

    const showButtons = loggedInUser?.roles?.SUPERUSER && isZim

    return <>
        <PageHeader header={'Esims'} />
        { showButtons && <RefreshWebsiteSalesButton />}
        <EsimsTable />
        { showButtons && <CustomStatsButton /> }
    </>
}
